
<script setup>

import { ref, onMounted, watch } from 'vue'

import { useWindowSize } from '@vueuse/core'

const { width: windowWidth } = useWindowSize()

import cloudUrl from 'url:../../images/cloud.svg'

const clouds = ref( [] )

const shuffleArray = ( array ) => {

  const shuffledArray = [ ...array ];

  for ( let i = shuffledArray.length - 1; i > 0; i-- ) {

    const j = Math.floor( Math.random() * ( i + 1 ) );

    [ shuffledArray[ i ], shuffledArray[ j ] ] = [ shuffledArray[ j ], shuffledArray[ i ] ];
    
  }

  return shuffledArray;
}

const generateClouds = ( screenWidth ) => {

  const numberOfClouds = 2

  const newClouds = []

  for ( let i = 0; i < numberOfClouds; i++ ) {

    const randomTop = Math.floor(Math.random() * 11) + (25 * i + 10)

    const randomDuration = Math.floor( Math.random() * 30 ) + 60

    const randomSize = Math.floor( Math.random() * 10 ) + 10

    const randomNumber = Math.round( Math.random() )

    newClouds.push( {

      topPosition: `${ randomTop }%`,

      duration: `${ screenWidth > 640 ? randomDuration : randomDuration - 30 }s`,

      size: `${ screenWidth < 640 ? randomSize * 2.5 : screenWidth < 1024 ? randomSize * 1.5 : randomSize }%`,

      randomNumber
      
    } )

  }

  clouds.value = shuffleArray( newClouds )

}

onMounted( () => generateClouds( windowWidth.value ) )

watch( windowWidth, newWindowWidth => generateClouds( newWindowWidth ) )

</script>

<template>

  <div>

    <!-- top-left -->
    <img :src="cloudUrl" class="absolute opacity-15 w-[50%] sm:w-[40%] lg:w-[30%] xl:w-[25%] top-[8%] left-[8%]" />

    <!-- bottom-left -->
    <img :src="cloudUrl" class="absolute opacity-15 w-[35%] sm:w-[30%] lg:w-[20%] xl:w-[15%] top-[30%] sm:top-[40%] left-[13%]" />

    <!-- top-right -->
    <img :src="cloudUrl" class="absolute opacity-15 w-[35%] sm:w-[30%] lg:w-[20%] xl:w-[15%] top-[3%] sm:top-[12%] right-[12%]" />
    
    <!-- bottom-right -->
    <img :src="cloudUrl" class="absolute opacity-15 w-[30%] sm:w-[25%] lg:w-[15%] xl:w-[12%] top-[25%] sm:top-[38%] right-[5%]" />
    
    <!-- middle -->
    <img :src="cloudUrl" class="hidden lg:block absolute opacity-15 w-[20%] xl:w-[15%] top-[28%] left-[55%]" />
    
    <!-- <img
    
      v-for="( cloud, index ) in clouds"

      :key="index"

      src="../../images/cloud.svg"

      alt="cloud"

      class="absolute opacity-10"

      :class="[ cloud.randomNumber ? 'animate-moveCloudRightLeft': 'animate-moveCloudLeftRight' ]"

      style="transform: translateX(-100%)"

      :style="{

        top: cloud.topPosition,

        animationDuration: cloud.duration,

        width: cloud.size,

        // animationDelay: `${ index * 2 }s`

      }"

    /> -->

  </div>

</template>